module.exports = __webpack_public_path__ + "img/user-6.6076ef12.jpg";